var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _g4, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductHostingClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2881_52597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEA\xB2\xA9\xEB\xA6\xAC \xEB\xAA\xA8\xEB\x93\x9C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.6377 24.9231C43.8054 13.5274 36.3246 2.53209 24.9289 0.364429C13.5332 -1.80324 2.53788 5.67757 0.370216 17.0733C-1.79745 28.469 5.68336 39.4643 17.0791 41.6319C28.4748 43.7996 39.4701 36.3188 41.6377 24.9231Z",
    fill: "url(#paint0_linear_2881_52597)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.0634 23.2991C26.5193 22.7998 25.6845 22.7998 25.1404 23.2991L21.682 26.4892C21.2199 26.914 20.5193 26.9215 20.0497 26.5041L6.41739 14.3774C5.62733 13.6768 4.41242 13.7364 3.69689 14.5116L0.171429 18.3575C0.0596273 19.2221 0 20.1091 0 21.0035C0 32.601 9.39876 42.0072 21.0037 42.0072C27.9727 42.0072 34.1366 38.6159 37.9602 33.3911L27.0634 23.3066V23.2991Z",
    fill: "url(#paint1_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.9615 33.3836L27.0646 23.2991C27.0646 23.2991 27.0646 23.2991 27.0571 23.2917C26.677 22.9413 26.0584 23.2246 26.0584 23.7463V23.9103C26.0584 24.8867 26.4236 25.8258 27.0795 26.5413C28.0112 27.5625 28.041 29.1202 27.1391 30.1712L25 32.6681L29.8745 40.0395C33.1019 38.5339 35.882 36.2308 37.9615 33.3836Z",
    fill: "url(#paint2_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.0039 41.9992C25.4834 41.9992 29.6349 40.5905 33.0411 38.198L19.6921 26.1756L6.41752 14.3694C6.41752 14.3694 6.41007 14.3694 6.40262 14.362C5.88088 13.9073 5.061 14.2874 5.061 14.9806C5.061 16.7247 4.50199 18.4166 3.47342 19.8179L0.246094 24.2228C0.559137 26.2651 1.17032 28.2104 2.02746 30.0141C2.13181 30.1483 2.25106 30.2675 2.34796 30.4092L6.61876 36.3048C10.3753 39.8377 15.4362 42.0067 20.9964 42.0067L21.0039 41.9992Z",
    fill: "url(#paint3_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.0821 39.8756C18.164 39.8234 18.1939 39.7116 18.1417 39.6222L17.6274 38.6905C17.6945 38.6532 17.7243 38.5712 17.687 38.4967L17.292 37.7886C17.3591 37.7737 17.3889 37.6992 17.3591 37.647L16.5839 36.2532C16.5839 36.2532 16.5168 36.2234 16.5019 36.2532L15.7268 37.647C15.697 37.7066 15.7268 37.7737 15.7939 37.7886L15.3988 38.4967C15.3616 38.5712 15.3914 38.6532 15.4585 38.6905L15.1827 39.1824L14.9442 38.7501C15.0634 38.6905 15.1156 38.5414 15.0485 38.4222L14.3703 37.1998C14.4821 37.1774 14.5342 37.0507 14.4821 36.9538L13.1479 34.5613C13.1181 34.5017 13.0361 34.5017 12.9988 34.5613L11.6647 36.9538C11.6125 37.0507 11.6647 37.1774 11.7765 37.1998L11.5305 37.6396L11.0982 36.8644C11.2175 36.8048 11.2696 36.6557 11.2025 36.5364L10.5243 35.3141C10.6361 35.2917 10.6883 35.165 10.6361 35.0681L9.30193 32.6756C9.27211 32.616 9.19013 32.616 9.15286 32.6756L7.8187 35.0681C7.76653 35.165 7.8187 35.2917 7.9305 35.3141L7.25224 36.5364C7.18516 36.6557 7.23733 36.8122 7.35659 36.8644L7.31932 36.9315C10.0622 39.2868 13.4162 40.9414 17.1057 41.6271C17.5901 41.5973 18.0671 41.5377 18.5367 41.4333C18.7081 41.3961 18.7976 41.2023 18.7081 41.0458L18.0522 39.8756H18.0821Z",
    fill: "url(#paint4_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M31.6412 38.9671L30.9629 37.7447C31.0747 37.7224 31.1269 37.5957 31.0747 37.4988L29.7405 35.1062C29.7107 35.0466 29.6287 35.0466 29.5915 35.1062L28.2573 37.4988C28.2051 37.5957 28.2573 37.7224 28.3691 37.7447L28.1232 38.1845L27.6909 37.4093C27.8101 37.3497 27.8623 37.2006 27.7952 37.0814L27.1169 35.859C27.2287 35.8367 27.2809 35.7099 27.2287 35.613L25.8946 33.2205C25.8648 33.1609 25.7828 33.1609 25.7455 33.2205L24.4114 35.613C24.3592 35.7099 24.4114 35.8367 24.5232 35.859L23.8449 37.0814C23.7778 37.2006 23.83 37.3571 23.9492 37.4093L23.1815 38.7807L22.8238 38.1323C22.9356 38.1099 22.9877 37.9832 22.9356 37.8863L21.6014 35.4938C21.5716 35.4342 21.4896 35.4342 21.4523 35.4938L20.1182 37.8863C20.066 37.9832 20.1182 38.1099 20.23 38.1323L19.7082 39.064L19.4325 38.5721C19.4995 38.5571 19.5294 38.4826 19.4995 38.4304L18.7244 37.0366C18.7244 37.0366 18.6573 37.0068 18.6424 37.0366L17.8673 38.4304C17.8374 38.4901 17.8673 38.5571 17.9343 38.5721L17.5393 39.2801C17.502 39.3547 17.5318 39.4367 17.5989 39.4739L17.0846 40.4056C17.0325 40.495 17.0623 40.6068 17.1443 40.659L16.6523 41.5385C18.0461 41.8292 19.4846 41.9857 20.9679 41.9857C24.8586 41.9857 28.5033 40.9199 31.6337 39.0789C31.6337 39.0342 31.6337 38.9969 31.6039 38.9596L31.6412 38.9671Z",
    fill: "url(#paint5_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.0858 36.7984L32.3106 38.1922C32.2808 38.2518 32.3106 38.3189 32.3777 38.3338L32.1094 38.8183C32.6535 38.4754 33.1827 38.1177 33.6895 37.7301L33.1752 36.7984C33.1752 36.7984 33.1081 36.7686 33.0932 36.7984H33.0858Z",
    fill: "url(#paint6_linear_2881_52597)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.9674 7.09512C12.4631 6.26034 10.2196 5.09015 8.68419 4.00195C8.38605 4.2181 8.09537 4.4417 7.80469 4.67276C12.001 6.26034 14.9674 7.09512 14.9674 7.09512Z",
    fill: "url(#paint7_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.63672 9.18884C7.6392 10.1876 11.038 10.5006 11.038 10.5006C8.95846 10.21 7.11746 9.46462 6.51374 8.85344C6.02927 8.36897 5.04541 8.2348 4.47895 8.04102C4.18827 8.41369 3.90504 8.79381 3.63672 9.18139V9.18884Z",
    fill: "url(#paint8_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.6445 11.2233C20.6445 11.2233 24.0955 11.8643 26.1153 11.4469C28.1278 11.0221 29.1787 11.9016 30.5427 11.3053C31.8992 10.709 33.0694 11.4916 33.4495 12.0655C33.8296 12.632 34.8582 12.0655 35.6184 12.5724C36.3861 13.0792 38.2942 13.0345 38.2942 13.0345C38.2942 13.0345 32.4656 14.8829 20.6445 11.2308V11.2233Z",
    fill: "url(#paint9_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.0039 7.01942C21.0039 7.01942 22.9045 7.46662 24.0598 7.18339C25.2151 6.90016 25.7517 7.49644 26.5492 7.09395C27.3468 6.69147 27.9579 7.22811 28.1368 7.61569C28.3157 8.00327 28.9269 7.61569 29.3294 7.966C29.7319 8.30886 30.8052 8.2865 30.8052 8.2865C30.8052 8.2865 27.4288 9.53122 21.0114 7.01942H21.0039Z",
    fill: "url(#paint10_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M15.5156 3.88992C15.5156 3.88992 17.7367 4.62781 18.7951 4.43402C18.7951 4.43402 18.1616 4.22532 17.9156 4.00172C17.6697 3.77812 17.1032 3.6365 16.8647 3.78557C16.6262 3.93464 16.5293 3.56942 16.261 3.71104C15.9926 3.85265 15.5231 3.89737 15.5231 3.89737L15.5156 3.88992Z",
    fill: "url(#paint11_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M29.543 4.50906C29.543 4.50906 31.7641 5.24695 32.8225 5.05316C32.8225 5.05316 32.1889 4.84446 31.943 4.62086C31.697 4.39726 31.1305 4.25564 30.892 4.40471C30.6535 4.55378 30.5566 4.18856 30.2883 4.33018C30.02 4.46434 29.5504 4.51651 29.5504 4.51651L29.543 4.50906Z",
    fill: "url(#paint12_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M26.4057 4.35161C26.4057 4.35161 24.6989 4.21745 24.043 3.78515C24.043 3.78515 24.5349 3.82242 24.7585 3.74788C24.9896 3.66589 25.4069 3.73298 25.5262 3.89695C25.6455 4.06838 25.8094 3.84478 25.951 4.01621C26.0927 4.18018 26.3982 4.35161 26.3982 4.35161H26.4057Z",
    fill: "url(#paint13_linear_2881_52597)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M30.5117 39.7198C30.78 39.5856 31.0409 39.444 31.2943 39.3024V16.3086H30.5117V39.7272V39.7198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M29.7297 17.1871L28.9844 17.4257L35.1633 36.4915C35.3794 36.2977 35.5881 36.0965 35.7968 35.8878L29.7297 17.1797V17.1871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M24.1172 41.7692C24.4079 41.7245 24.706 41.6723 24.9892 41.6202L32.8302 17.4338L32.0849 17.1953L24.1172 41.7692Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M35.0527 31.1032H21.8751C21.1372 31.1032 20.5931 30.4175 20.7496 29.7019L26.4291 4.39014C26.5484 3.86095 27.0105 3.48828 27.5546 3.48828H40.7322C41.4701 3.48828 42.0142 4.174 41.8577 4.88952L36.1782 30.2013C36.059 30.7305 35.5968 31.1032 35.0527 31.1032Z",
    fill: "url(#paint14_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M36.5568 13.2077L30.4003 19.3642C30.132 19.6326 29.6699 19.5729 29.491 19.2375L28.1717 16.8599C27.963 16.4872 27.4637 16.4052 27.1506 16.6959L22.7606 20.7729L20.7556 29.7021C20.5916 30.4251 21.1432 31.1034 21.8811 31.1034H35.0587C35.5954 31.1034 36.0649 30.7307 36.1842 30.2015L39.3295 16.1965L37.6301 13.3344C37.4065 12.9543 36.8773 12.8872 36.5643 13.2003L36.5568 13.2077Z",
    fill: "url(#paint15_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M37.1836 13.0282C37.1388 13.0133 37.1016 13.0059 37.1016 13.0059L37.1836 13.0282Z",
    fill: "url(#paint16_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M37.6175 13.3407C37.5355 13.2066 37.4163 13.1097 37.2821 13.0575L37.1852 13.0352C37.4088 13.1171 37.9008 13.5494 36.3579 15.7407C34.4796 18.4016 31.9529 21.6737 34.8747 21.614C37.7964 21.547 32.3405 29.5892 29.5977 31.1097H35.0536C35.5902 31.1097 36.0598 30.737 36.179 30.2078L39.3244 16.2029L37.625 13.3407H37.6175Z",
    fill: "url(#paint17_linear_2881_52597)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M30.3939 19.3632C30.1256 19.6315 29.6635 19.5719 29.4846 19.2365L28.1653 16.8588C28.0461 16.6427 27.8225 16.5234 27.5989 16.5234C27.5989 16.5234 28.5156 16.9632 27.5318 18.0439C26.5479 19.1247 25.0125 20.921 26.8088 20.757C28.6051 20.593 23.343 24.8265 24.8784 24.275C26.4138 23.716 30.7889 18.9756 31.6386 18.1259L30.3939 19.3706V19.3632Z",
    fill: "url(#paint18_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M30.5444 11.1951C31.0661 10.2932 31.9755 9.85349 32.5792 10.1963C33.1829 10.5467 33.25 11.5529 32.7357 12.4547C32.214 13.3566 31.3046 13.7963 30.7009 13.4535C30.0972 13.1032 30.0301 12.097 30.5444 11.1951Z",
    fill: "url(#paint19_linear_2881_52597)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M25.6698 24.6857C25.8412 24.3727 25.8412 24.0149 25.6996 23.7168C25.3717 23.7615 25.0735 23.9479 24.9021 24.2609C24.7307 24.5739 24.7307 24.9317 24.8723 25.2298C25.2002 25.1851 25.4984 24.9988 25.6698 24.6857Z",
    fill: "#F9A141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_25",
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8203 25.1035C24.8203 25.1035 24.8427 25.1706 24.8576 25.2078L24.8799 25.2302C25.2004 25.1855 25.4986 24.9917 25.67 24.6861C25.8414 24.3805 25.8414 24.0227 25.6998 23.7246C25.6104 23.8141 25.5209 23.9482 25.5433 24.1345C25.588 24.47 25.5433 24.4401 25.2228 24.5818C24.9619 24.6936 24.8576 24.9842 24.8203 25.1035Z",
    fill: "url(#paint20_linear_2881_52597)",
    style: {
      mixBlendMode: "color-burn"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8203 25.1035C24.8203 25.1035 24.8427 25.1706 24.8576 25.2078L24.8799 25.2302C25.2004 25.1855 25.4986 24.9917 25.67 24.6861C25.8414 24.3805 25.8414 24.0227 25.6998 23.7246C25.6104 23.8141 25.5209 23.9482 25.5433 24.1345C25.588 24.47 25.5433 24.4401 25.2228 24.5818C24.9619 24.6936 24.8576 24.9842 24.8203 25.1035Z",
    stroke: "black",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M24.8873 25.1034C24.8352 25.0736 24.7681 25.0885 24.7234 25.1332C24.2687 25.6922 23.4936 26.9295 22.6811 28.4053C21.5408 30.4922 20.7656 32.2661 20.9594 32.3705C21.1457 32.4748 22.2265 30.8649 23.3668 28.7854C24.1793 27.3096 24.7979 25.9829 25.029 25.3046C25.0513 25.245 25.029 25.1854 24.9693 25.1556L24.8873 25.1109V25.1034Z",
    fill: "#38826D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M24.284 26.0429L24.4927 26.1621C24.5523 26.192 24.5896 26.2367 24.6194 26.2963C24.7983 25.8938 24.9399 25.5584 25.0219 25.305C25.0442 25.2454 25.0219 25.1857 24.9623 25.1559L24.8803 25.1112C24.8281 25.0814 24.761 25.0963 24.7163 25.141C24.5523 25.3497 24.3362 25.6479 24.0977 26.0131C24.1573 26.0131 24.2244 26.0131 24.2765 26.0503L24.284 26.0429Z",
    fill: "#80A096"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M6.15475 9.53289C6.15475 9.53289 7.60072 7.26705 6.71376 4.72544C6.71376 4.72544 7.07898 1.94531 11.6256 1.94531L12.4827 4.71798C12.52 4.85214 12.602 4.96395 12.7063 5.05339L12.9597 5.26208C13.1461 5.41115 13.1237 5.72419 12.9672 5.90308C12.4007 6.57388 12.7808 7.74407 11.8268 8.46705C11.0293 9.07078 9.32991 7.69935 9.38954 10.2931C9.38954 10.2931 3.82929 12.6112 6.1473 9.53289H6.15475Z",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M13.081 5.68615C13.0214 5.70106 12.9543 5.70851 12.8947 5.70106C12.7158 5.70106 12.5146 5.4551 12.5369 5.26131C12.5518 5.16441 12.5742 5.03771 12.604 4.93336C12.5593 4.87373 12.5146 4.7992 12.4922 4.72466L8.51953 4.1582L6.97667 5.91721C7.17046 7.92963 6.15679 9.52466 6.15679 9.52466C6.03009 9.69609 5.92574 9.84516 5.84375 9.98677L8.77294 10.0315C8.77294 10.0315 8.14686 9.68119 8.35555 9.13709C8.56425 8.59299 9.81642 8.80913 9.81642 8.80913C10.1518 8.54827 10.6363 8.63025 11.0835 8.63771H11.1208C10.2562 8.57808 10.3829 7.47497 10.45 6.68491C10.5319 5.75323 11.0537 5.29112 11.7469 5.20913C12.44 5.12715 12.686 6.52839 12.686 6.52839C12.7456 6.29733 12.8276 6.08118 12.9767 5.9023C13.0288 5.84268 13.0661 5.76069 13.081 5.6787V5.68615Z",
    fill: "url(#paint21_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M18.2227 23.1354C18.2227 23.1354 18.4239 22.5839 19.0351 22.4572C19.6463 22.3305 21.4798 22.0845 21.3233 22.3528C21.1668 22.6211 19.0351 23.3441 18.804 23.441",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M6.15637 9.5332C6.15637 9.5332 0.297984 10.4574 4.52407 18.9916C8.14643 26.3034 14.3775 28.4649 16.7551 26.4003C18.3651 24.999 18.9241 23.9854 19.1179 23.4711C19.1998 23.2475 19.0657 23.009 18.8346 22.9643C18.5216 22.9046 17.9998 22.6959 17.5303 23.1133C16.7104 23.8512 14.8098 25.0736 14.3775 24.3357",
    fill: "#304FA5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M19.9023 30.4555L21.2961 29.5015C21.4899 29.3673 21.7284 29.3002 21.9669 29.3226C22.2874 29.345 22.7048 29.3971 22.7719 29.4866C23.1669 30.0083 23.0626 31.0741 22.8912 31.0891C22.7943 31.0891 22.5632 31.0443 22.3694 30.9922C22.1905 30.9474 21.9968 30.9773 21.8477 31.0816C21.5794 31.2679 21.1098 31.5064 20.685 31.3425",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M7.99609 27.5469C9.00976 30.7668 9.01721 34.3891 8.53274 37.8997C10.0607 39.0326 11.7526 39.9568 13.5563 40.6425C15.7998 34.1581 15.6657 28.7767 15.6657 28.7767L8.00355 27.5543L7.99609 27.5469Z",
    fill: "#F9A141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M7.99609 27.5469C7.99609 27.5469 8.011 27.5916 8.01845 27.614C8.06318 27.7481 8.1079 27.8897 8.14516 28.0239C8.89796 30.8786 8.9874 34.5382 8.57001 37.922C10.098 39.0475 11.7899 39.9717 13.5936 40.65C15.2706 36.886 15.2334 33.5841 15.5017 31.3854L12.8185 28.3146L8.00355 27.5469H7.99609Z",
    fill: "url(#paint22_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M7.99609 27.3395C11.6185 31.737 13.7203 36.6787 14.9352 41.1134C16.4855 41.583 18.1178 41.8737 19.7949 41.9706C19.847 33.0116 17.9464 26.4004 17.9464 26.4004L7.99609 27.347V27.3395Z",
    fill: "#F9A141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M18.4313 28.0469L9.38281 29.1202C12.1108 32.8692 13.8176 37.1624 14.8685 41.0904C15.2487 41.2022 15.6288 41.3065 16.0164 41.4034C16.0611 39.5102 16.3592 37.9748 17.2014 37.4382C19.8325 35.7612 18.4387 28.0692 18.4313 28.0543V28.0469Z",
    fill: "url(#paint23_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M5.92593 9.66027C5.92593 9.66027 2.29612 15.1907 5.59798 22.1298C8.89984 29.0764 5.42655 28.1447 8.48245 29.0093C11.5384 29.8739 18.88 30.4106 18.403 27.7721C17.9334 25.141 12.4924 17.151 12.3582 15.1236C12.2166 13.0963 10.4427 10.7708 9.39922 10.2864C8.34829 9.80188 6.31351 9.17579 5.92593 9.65281V9.66027Z",
    fill: "#4C68B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M9.39922 10.2922C8.34829 9.80774 6.31351 9.18165 5.92593 9.65867C5.92593 9.65867 2.29612 15.1891 5.59798 22.1282C8.89984 29.0748 5.42655 28.1431 8.48245 29.0077C9.97314 29.4326 12.4849 29.7754 14.6166 29.7084C12.2837 29.604 11.911 27.4798 13.8936 26.1233C15.8762 24.7742 13.2601 24.2152 11.3818 21.5767C9.50357 18.9307 14.6166 20.0711 14.6166 20.0711C13.4315 17.9245 12.4179 15.9866 12.3582 15.122C12.2166 13.0947 10.4427 10.7692 9.39922 10.2848V10.2922Z",
    fill: "url(#paint24_linear_2881_52597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M8.56378 11.5756C8.95882 10.793 9.07807 9.9806 9.77124 10.5247C10.9042 11.4117 13.3861 13.67 14.0868 16.5173C15.242 21.198 19.7141 29.2328 21.0781 29.2179C22.4495 29.203 20.5861 31.7968 20.057 31.4464C19.5576 31.1185 4.45695 19.7148 8.55633 11.5756H8.56378Z",
    fill: "#4C68B0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M22.6797 22.166C22.6797 22.5238 20.9654 22.5909 19.6685 22.5909C18.3716 22.5909 17.9766 22.5238 17.9766 22.166C17.9766 21.8083 19.0275 21.5176 20.3318 21.5176C21.6362 21.5176 22.6871 21.8083 22.6871 22.166H22.6797Z",
    fill: "#DFECF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M20.072 22.0021C20.072 22.0691 19.9006 22.1213 19.6845 22.1213C19.4683 22.1213 19.2969 22.0691 19.2969 22.0021C19.2969 21.935 19.4683 21.8828 19.6845 21.8828C19.9006 21.8828 20.072 21.935 20.072 22.0021Z",
    fill: "#F9A141"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M21.0868 22.1213C21.3008 22.1213 21.4744 22.0679 21.4744 22.0021C21.4744 21.9362 21.3008 21.8828 21.0868 21.8828C20.8727 21.8828 20.6992 21.9362 20.6992 22.0021C20.6992 22.0679 20.8727 22.1213 21.0868 22.1213Z",
    fill: "#38826D"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M13.11 1.74325C13.4901 2.42897 13.5423 3.2563 13.1919 3.95692C12.9609 4.41158 12.5584 4.85133 11.8503 4.88114C10.6652 4.93332 10.1659 5.90226 10.0019 6.33456C9.95716 6.46127 9.83791 6.54325 9.70374 6.54325C9.54722 6.54325 9.41306 6.43145 9.38325 6.27493C9.33853 5.99916 9.24909 5.58922 9.06275 5.38797C8.71244 5.00785 7.66896 5.34325 8.1907 6.54325C8.71244 7.74325 8.08635 8.0563 8.08635 8.0563H6.7671C6.7671 8.0563 4.20312 3.97183 5.11989 1.95195C6.03666 -0.0679259 11.5298 -1.08159 13.1025 1.75071L13.11 1.74325Z",
    fill: "#8E241C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M9.32434 0C7.48335 0.0447205 5.6349 0.842236 5.13552 1.94534C4.21875 3.96522 6.78272 8.04969 6.78272 8.04969H8.10198C8.10198 8.04969 8.72807 7.73665 8.20633 6.53665C7.85602 5.72422 8.20633 5.30683 8.5939 5.23975C8.10943 5.09814 7.25229 5.79876 7.25229 5.23975C7.25229 4.68075 8.75788 3.86832 7.16285 2.24348C5.61999 0.693168 9.0113 0.0596273 9.32434 0Z",
    fill: "url(#paint25_linear_2881_52597)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2881_52597",
    x1: 21.0025,
    y1: 69.9354,
    x2: 21.0025,
    y2: 3.85345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2881_52597",
    x1: 18.9764,
    y1: 46.5612,
    x2: 18.9764,
    y2: -21.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2881_52597",
    x1: 31.477,
    y1: 48.1712,
    x2: 31.477,
    y2: 5.76122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2881_52597",
    x1: 16.6436,
    y1: 51.3756,
    x2: 16.6436,
    y2: 2.48866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2881_52597",
    x1: 12.9988,
    y1: 47.1203,
    x2: 12.9988,
    y2: 31.7215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2881_52597",
    x1: 24.1803,
    y1: 46.9571,
    x2: 24.1803,
    y2: 31.8714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2881_52597",
    x1: 32.8994,
    y1: 39.9661,
    x2: 32.8994,
    y2: 36.4705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2881_52597",
    x1: 11.3823,
    y1: 11.5075,
    x2: 11.3823,
    y2: -7.49122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2881_52597",
    x1: 7.33361,
    y1: 15.2634,
    x2: 7.33361,
    y2: -9.43725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2881_52597",
    x1: 29.4694,
    y1: 19.4072,
    x2: 29.4694,
    y2: -26.7444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2881_52597",
    x1: 25.9008,
    y1: 19.407,
    x2: 25.9008,
    y2: -26.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2881_52597",
    x1: 17.1554,
    y1: 19.4079,
    x2: 17.1554,
    y2: -26.7511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2881_52597",
    x1: 31.1753,
    y1: 13.4532,
    x2: 31.1753,
    y2: -32.6984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2881_52597",
    x1: 25.2206,
    y1: 19.4075,
    x2: 25.2206,
    y2: -26.7515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2881_52597",
    x1: 27.8676,
    y1: 46.3082,
    x2: 35.9844,
    y2: -22.2931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2881_52597",
    x1: 38.2562,
    y1: 44.8922,
    x2: 27.6276,
    y2: 16.8897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2881_52597",
    x1: 48.1625,
    y1: 29.0673,
    x2: 38.2873,
    y2: 14.6824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2881_52597",
    x1: 34.4573,
    y1: 43.6687,
    x2: 34.4573,
    y2: 21.2339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2881_52597",
    x1: 32.2498,
    y1: 24.4464,
    x2: 27.8672,
    y2: 21.0104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2881_52597",
    x1: 31.3121,
    y1: 15.928,
    x2: 33.1829,
    y2: -7.44588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAF1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#7DEFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2881_52597",
    x1: 27.619,
    y1: 23.0701,
    x2: 21.745,
    y2: 26.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2881_52597",
    x1: 11.6798,
    y1: 10.9259,
    x2: 6.47729,
    y2: 3.53957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2881_52597",
    x1: 0.237087,
    y1: 51.6885,
    x2: 5.29796,
    y2: 43.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F89A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F78925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F56C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2881_52597",
    x1: 13.4077,
    y1: 53.1798,
    x2: 14.3393,
    y2: 22.7102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F89A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F78925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F56C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2881_52597",
    x1: 0.574378,
    y1: 28.4115,
    x2: 32.8849,
    y2: -0.649402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C68B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3A50A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3345A2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2881_52597",
    x1: -4.69554,
    y1: 12.9391,
    x2: 16.4722,
    y2: -2.23603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E241C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#721A14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2881_52597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductHostingClass);
export default __webpack_public_path__ + "static/media/icon_product_hosting_class.9ac4dff1141030131dec6745d6787a47.svg";
export { ForwardRef as ReactComponent };